import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import InvoiceHeader from "../InvoiceHeader";
import InvoiceDetails5 from "../invoiceDetails/InvoiceDetails5";
import InvoiceDetailsRow from "../invoiceDetails/InvoiceDetailsRow";
import InvoiceFooter from "../InvoiceFooter";
import ServiceTable from "../serviceInvoice/ServiceTable";
import { InvoiceDataType } from "../../../api/invoice";

type ComponentProps = { data?: InvoiceDataType };

const ComponentOne: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceHeader data={data} />
);
const ComponentTwo: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow data={data} rowIndex={0} />
);
const ComponentThree: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetailsRow data={data} rowIndex={4} />
);
const ComponentFour: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetails5 showBillToService data={data} />
);
const ComponentFive: React.FC<ComponentProps> = ({ data }) => (
  <InvoiceDetails5 showClientDetails data={data} />
);
const ComponentSix: React.FC<ComponentProps> = ({ data }) => (
  <ServiceTable data={data} />
);
const ComponentNine: React.FC = () => (
  <InvoiceFooter showSignaturesOnly={true} />
);
const ComponentTen: React.FC<ComponentProps> = ({ data }) => (
  <div
    data-testid="remarks-section"
    style={{
      borderTop: "3px solid black",
      fontSize: "10px",
      fontFamily: "Inter",
      textAlign: "start",
      padding: "5px",
    }}
  >
    <span style={{ fontSize: "10px", fontWeight: 500 }}>Remarks:</span> Cold
    Chain Logistics Supply for {data?.service?.liters ?? "__"} litres beer.
  </div>
);
// Row configuration to whether to span two columns and the components to render
const rows = [
  { components: [ComponentOne], spanTwoColumns: true },
  { components: [ComponentTwo, ComponentThree], spanTwoColumns: false },
  { components: [ComponentFour, ComponentFive], spanTwoColumns: false },
  { components: [ComponentSix], spanTwoColumns: true },
  { components: [ComponentNine], spanTwoColumns: true },
  { components: [ComponentTen], spanTwoColumns: true },
];

const ServiceInvoiceScreen: React.FC<ComponentProps> = ({ data }) => {
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table
          sx={{ "& .MuiTableCell-root.MuiTableCell-root": { padding: "0px" } }}
        >
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row.spanTwoColumns ? (
                  // If the row spans two columns, render the components in one cell
                  <TableCell colSpan={2} sx={{ textAlign: "center" }}>
                    {row.components.map((Component, index) => (
                      <Component key={index} data={data} />
                    ))}
                  </TableCell>
                ) : (
                  // If the row does not span two columns, render components in separate cells
                  <>
                    {row.components.map((Component, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          borderRight: index === 0 ? "3px solid black" : "",
                          borderBottom: "3px solid black",
                          verticalAlign: "top",
                          width: "50%",
                        }}
                      >
                        <Component data={data} />
                      </TableCell>
                    ))}
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ServiceInvoiceScreen;
